import { addressSplit, sanitizeEnum, VALID_LOCATION_TYPES, VALID_DROPOFF_TYPES as VALID_PICKUP_TYPES } from './processOrders';
import { toE164, validate as validatePhone } from '@/utilities/formatPhoneNumber';
import { PICKUP_INFO_FIELDS } from '../modals/InputFields';

export const buildForwardStockingPickupInfo = ({ pickup_location, carrier_name, carrier_phone, carrier_id } = {}) => {
    const base = {
        order_type: 'delivery',
        is_middle_mile: false,
        is_middle_mile_origin: false,
        carrier_id: carrier_id || null,
        carrier_assignment_source: carrier_id ? 'DIRECT' : null,
        [PICKUP_INFO_FIELDS.FIRST_AVAILABLE]: new Date(new Date().setHours(0, 0, 0, 0)).toISOString(),
    };

    if (!pickup_location) {
        return base;
    }

    const [street, unit] = addressSplit(pickup_location.business_address);
    const fullAddress =
        pickup_location.address ||
        `${pickup_location.business_address}, ${pickup_location.business_city}, ${pickup_location.business_state} ${pickup_location.business_zip}`;

    return {
        ...base,
        [PICKUP_INFO_FIELDS.IS_CUSTOM]: false,
        pickupfulladdress: fullAddress,
        [PICKUP_INFO_FIELDS.FULL_ADDRESS]: fullAddress,
        [PICKUP_INFO_FIELDS.STREET]: street,
        [PICKUP_INFO_FIELDS.ADDRESS_LINE_2]: unit,
        [PICKUP_INFO_FIELDS.CITY]: pickup_location.business_city,
        [PICKUP_INFO_FIELDS.STATE]: pickup_location.business_state,
        [PICKUP_INFO_FIELDS.ZIP]: pickup_location.business_zip,
        [PICKUP_INFO_FIELDS.COMMENTS]: pickup_location.shipper_pu_comments || '',
        [PICKUP_INFO_FIELDS.LOCATION_TYPE]: sanitizeEnum(pickup_location.location_type, VALID_PICKUP_TYPES) || 'Business',
        [PICKUP_INFO_FIELDS.PICKUP_TYPE]: sanitizeEnum(pickup_location.location_info, VALID_LOCATION_TYPES) || 'dock',
        [PICKUP_INFO_FIELDS.NAME]: pickup_location.contact_name || carrier_name || '',
        [PICKUP_INFO_FIELDS.PHONE]: validatePhone(pickup_location.contact_phone)
            ? toE164(pickup_location.contact_phone)
            : validatePhone(carrier_phone)
            ? toE164(carrier_phone)
            : '',
        [PICKUP_INFO_FIELDS.EMAIL]: pickup_location.contact_email || '',
        ...(pickup_location.lat && pickup_location.lng
            ? { [PICKUP_INFO_FIELDS.LAT]: pickup_location.lat, [PICKUP_INFO_FIELDS.LONG]: pickup_location.lng }
            : {}),
    };
};
